import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `div.activities-multiselect {
  & li.p-multiselect-option-group {
    background: ${dt('activitiesMultiselect.group.background')};
    color: ${dt('activitiesMultiselect.group.color')};
    font-weight: ${dt('activitiesMultiselect.group.fontWeight')};
    font-size: ${dt('activitiesMultiselect.group.fontSize')};
  }

  & li.p-multiselect-option {
    background: ${dt('activitiesMultiselect.item.background')};
  }

  & li.p-multiselect-option,
  & li.p-multiselect-option:not(.p-multiselect-option-selected):not(.p-disabled).p-focus {
    color: ${dt('activitiesMultiselect.item.color')};
    font-weight: ${dt('activitiesMultiselect.item.fontWeight')};
    font-size: ${dt('activitiesMultiselect.item.fontSize')};

    & div.selected {
      color: ${dt('activitiesMultiselect.itemSelected.color')};
      font-weight: ${dt('activitiesMultiselect.itemSelected.fontWeight')};
      font-size: ${dt('activitiesMultiselect.itemSelected.fontSize')};
    }
  }
}`;
